import React from "react";

import style from "./style.module.css";

export default function Text({ className = "", children }) {
    return (
        <div className={`${className ? className : ''}${style[className] ? ` ` + style[className] : ''}`}>{children}</div>
    )
}